import { getPublicBranding } from './branding';
import type { EffectiveBranding } from './branding.types';

type Inflight = Promise<EffectiveBranding>;

const inflight = new Map<string, Inflight>();

function cacheKey(tenantId?: string): string {
  return (tenantId || '__default__').trim() || '__default__';
}

/** Single-flight wrapper for GET public branding (shared by auth shell + landing). */
export function fetchPublicBrandingDeduped(tenantId?: string): Promise<EffectiveBranding> {
  const key = cacheKey(tenantId);
  const existing = inflight.get(key);
  if (existing) return existing;

  const promise = getPublicBranding(tenantId).finally(() => {
    if (inflight.get(key) === promise) {
      inflight.delete(key);
    }
  });
  inflight.set(key, promise);
  return promise;
}

/** Test-only reset. */
export function __resetPublicBrandingInflightForTests(): void {
  inflight.clear();
}
